import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Product } from './product';
import { CategoryView, CategoryViewProxy } from '../views/category';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { ProductType } from '../types';
import { CategoryDepType } from '../types';
import { ProductOptType } from '../types';
import { I18nValueType } from '../types';

const _schema = {
    "name": "CATEGORY",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "product", type: "objid" },
        { name: "name", type: "objid" },
        { name: "sort", type: "number" },
        { name: "type", type: "string" },
        { name: "fxmin", type: "number" },
        { name: "fxmax", type: "number" }
    ],
    relate: [
        { direction: ">", target: "PRODUCT", by: "product", name: "product", reason: "product", child: false, class: ProductType },
        { direction: ">", target: "I18NVALUE", by: "name", name: "name", reason: "name", child: true, class: I18nValueType },
        { direction: "<", target: "PRODUCTOPT", by: "category", name: "option", reason: "options", child: true, class: ProductOptType  },
        { direction: "<", target: "CATEGORYDEP", by: "category", name: "depend", reason: "depends", child: true, class: CategoryDepType }
    ]
} as const;

const _CategoryClass = CreateObject(_schema);
if (!_CategoryClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class Category extends _CategoryClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Category {
        return this._Copy(store) as Category;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'product' && related instanceof Product){
            if (related === this.product){
                related.AddCategory(this);
            }
        }
    }

    override get viewProxy(): CategoryView {
        return CategoryViewProxy(this, this.data);
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status']
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.product){
            if ((this.status == 'DE') && !this.Commited){
                this.product.DelCategory(this);
            }
            else {
                this.product.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CATALOG CONSIDERATIONS   */
    /****************************/

    override get IsCatalog(): boolean {
        return super.IsCatalog;
    }

    override set IsCatalog(value: boolean){
        if (value == this.IsCatalog){
            return;
        }

        super.IsCatalog = value;
        if (value == false){
            if (this.status == 'CT'){
                this.status = 'AC';
            }

            for (const _child of this.Children){
                _child.IsCatalog = value;
            }
        }
    }
        
    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

